var map = {
	"./pic1.jpg": 174,
	"./pic2.jpg": 175,
	"./pic3.jpg": 176,
	"./pic4.jpg": 177,
	"./pic5.jpg": 178,
	"./pic6.jpg": 179,
	"./pic7.jpg": 180,
	"./pic8.jpg": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;